import React, { PureComponent } from 'react';
import styled from 'styled-components';

export default class HeroTextWave extends PureComponent {

  constructor() {
    super();
    this.title = React.createRef();
  }

  componentDidMount() {
    const splitTarget = this.title.current.children;

    this.heroTitleText = new SplitText(splitTarget, { type: 'words, lines, chars' });
    const characters = this.heroTitleText.chars;

    this.titleTl = new TimelineMax({
      onComplete: this.resetText,
    });

    this.titleTl
      .set(this.title.current, { opacity: 1 })
      .set(this.heroTitleText.words, { whiteSpace: 'nowrap' })
      .set(this.heroTitleText.lines, { whiteSpace: 'nowrap' })
      .set(characters, { willChange: 'transform, opacity' })
      .staggerFrom(characters, 0.7, { opacity: 0, scale: 0.37, y: 40, rotation: '10deg', transformOrigin: '0% 50% -20', stagger: { from: 'center', amount: 0.44 }, ease: Back.easeOut.config(1.8) }, 'null', '+=.7');
  }

  animateTitle = () => {
    this.titleTl.play();
  }

  resetText = () => {
    this.heroTitleText.revert();
  }

  componentWillUnmount() {
    this.titleTl.kill();
  }

  render() {
    return (
      <HeroTextWrapper ref={this.title} style={{ fontKerning: 'none' }}>
        {this.props.children}
      </HeroTextWrapper>
    );
  }
}

const HeroTextWrapper = styled.span`
  opacity: 0;
  position: relative;
  z-index: 2;
`;
